import { render } from "./InstatntNotification.vue?vue&type=template&id=08ba52d2&scoped=true"
import script from "./InstatntNotification.vue?vue&type=script&lang=js"
export * from "./InstatntNotification.vue?vue&type=script&lang=js"

import "./InstatntNotification.vue?vue&type=style&index=0&id=08ba52d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ba52d2"]])

export default __exports__